import { render } from "./Galleries.vue?vue&type=template&id=37a64f34"
import script from "./Galleries.vue?vue&type=script&lang=js"
export * from "./Galleries.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__